import React, { memo } from 'react';
import { View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { HISTOGRAM_BAR_SIZE_CHART, AnimatedHistogramBar, } from 'design-system/HistogramBar';
import { Spacer } from 'design-system';
import { rem } from 'design-system/values';
import Text from 'design-system/Text';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { isDefaultCategory } from 'hooks/useCategory';
const HORIZONTAL_MARGIN = rem(13.5);
const BAR_SIZE = 'wide';
export const OUTER_WIDTH = HISTOGRAM_BAR_SIZE_CHART[BAR_SIZE] + HORIZONTAL_MARGIN * 2;
const CategoriesHistogramBar = ({ item, categoryMerchantSelected, barColor, isSelected, onPress, barContainerHeight, baselineTop, baselineHeight, }) => {
    const styles = useStyles(styleSet);
    const { signedHeight, label } = item;
    const textColor = isSelected
        ? { OffBlack: true }
        : { Gray: true };
    const [upwards, height] = signedHeight < 0 ? [false, -signedHeight] : [true, signedHeight];
    return (<TouchableOpacity onPress={onPress}>
      <View style={[
            { height: barContainerHeight },
            upwards
                ? { paddingBottom: barContainerHeight - baselineTop }
                : { paddingTop: baselineTop + baselineHeight },
            upwards ? styles.justifyEnd : styles.justifyStart,
        ]}>
        <AnimatedHistogramBar height={height} size={BAR_SIZE} color={barColor} style={[
            styles.bar,
            !isSelected && {
                opacity: categoryMerchantSelected === 'cash' ||
                    categoryMerchantSelected === 'housing' ||
                    (typeof categoryMerchantSelected === 'string' &&
                        !isDefaultCategory(categoryMerchantSelected))
                    ? 0.3
                    : 0.2,
            },
        ]} upsideDown={!upwards}/>
      </View>
      <Spacer.H16 />
      <Text Text-12 centered {...textColor}>
        {label}
      </Text>
    </TouchableOpacity>);
};
const styleSet = createStyleSheets(() => ({
    bar: {
        marginHorizontal: HORIZONTAL_MARGIN,
    },
    justifyStart: {
        justifyContent: 'flex-start',
    },
    justifyEnd: {
        justifyContent: 'flex-end',
    },
}));
export default memo(CategoriesHistogramBar);
